import { render, staticRenderFns } from "./XHelpDefault.vue?vue&type=template&id=3797a51e&scoped=true"
import script from "./XHelpDefault.vue?vue&type=script&lang=js"
export * from "./XHelpDefault.vue?vue&type=script&lang=js"
import style0 from "./XHelpDefault.vue?vue&type=style&index=0&id=3797a51e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3797a51e",
  null
  
)

export default component.exports